<template>
  <bl-modal-mv :is-active.sync="localIsActive" :title="tnc.title" max-width="851px">
    <div>
      <ol>
        <li v-for="(item, idx) in tnc.items" :key="idx" class="tnc-modal__item mb-16">
          <bl-text-av v-html="item" />
        </li>
      </ol>
    </div>

    <div slot="footer" class="p-24">
      <bl-button-av size="large" is-block @click="onAcceptClick">
        {{ tnc.cta }}
      </bl-button-av>
    </div>
  </bl-modal-mv>
</template>
<script>
import getTnc from 'shared/modules/seo/Tnc';
import queryString from 'query-string';
import BlTextAv from '@bukalapak/bazaar-dweb-2/dist/components/BlTextAv';
import BlModalMv from '@bukalapak/bazaar-dweb-2/dist/components/BlModalMv';
import BlButtonAv from '@bukalapak/bazaar-dweb-2/dist/components/BlButtonAv';

export default {
  name: 'TncModal',

  components: {
    BlTextAv,
    BlModalMv,
    BlButtonAv,
  },

  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      localIsActive: this.isActive,
    };
  },

  computed: {
    tnc() {
      return getTnc(this.$root.isSSR);
    },
  },

  watch: {
    isActive(value) {
      this.localIsActive = value;
    },
    localIsActive(value) {
      this.$emit('update:isActive', value);
    },
  },

  methods: {
    onAcceptClick() {
      this.localIsActive = false;

      window.location.href = `/login?${queryString.stringify({
        comeback: `/bukaemas${this.$route.fullPath}`,
        direct: 1,
      })}`;
    },
  },
};
</script>
